import { put } from "redux-saga/effects";
import { checkEgibilityFone } from "../../Services";

export function* checkEgibilityFoneSaga(action) {
  const payload = action.payload;
  try {
    const res = yield checkEgibilityFone(payload);

    // console.log("res", res);
    yield put({ type: "REQ_ONE_ELIGIBILITY_SUCCESS", data: res.data });
  } catch (error) {
    // console.log("tes", error.response.data);
    yield put({
      type: "REQ_ONE_ELIGIBILITY_FAILED",
      data: error.response.data,
    });
  }
}
